import { dia } from "@clientio/rappid";

import { Choice } from "../mvc/choice";
import { Entry } from "../mvc/entry";
import { Final } from "../mvc/final";
import { State } from "../mvc/state";
import { Synchronization } from "../mvc/synchronization";
import { Exit } from "../mvc/exit";
import { Region } from "../mvc/region";
import { Note } from "../mvc/note";

export class StencilService {
  getContent(): Array<dia.Cell | joint.mvc.ObjectHash> {
    return [
      this.createState(),
      this.createRegion(),
      this.createEntry(),
      this.createDeepHistory(),
      this.createShallowHistory(),
      new Final().attr("root/dataTooltip", "Final State"),
      new Exit().attr("root/dataTooltip", "Exit Node"),
      new Choice().attr("root/dataTooltip", "Choice"),
      new Synchronization().attr("root/dataTooltip", "Synchronization"),
      this.createNote(),
    ];
  }

  protected createState() {
    const state = new State().attr("root/dataTooltip", "State");
    state.setName("");
    state.attributes["size"] = { width: 30, height: 30 };
    return state;
  }

  protected createRegion() {
    const region = new Region().attr("root/dataTooltip", "Region");
    region.setName("");
    region.attributes["size"] = { width: 30, height: 30 };
    return region;
  }

  protected createEntry() {
    const entry = new Entry().attr("root/dataTooltip", "Entry Node");
    entry.setEntryKind("Initial");
    return entry;
  }
  protected createDeepHistory() {
    const deepHistory = new Entry().attr("root/dataTooltip", "Deep History");
    deepHistory.setEntryKind("DeepHistory");
    return deepHistory;
  }
  protected createShallowHistory() {
    const shallowHistory = new Entry().attr("root/dataTooltip", "Shallow History");
    shallowHistory.setEntryKind("ShallowHistory");
    return shallowHistory;
  }

  protected createNote() {
    const note = new Note().attr("root/dataTooltip", "Note");
    note.setText("");
    note.attributes["size"] = { width: 30, height: 30 };
    return note;
  }
}
